import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const DividerDiv = styled.div.withConfig({
  displayName: "Divider__DividerDiv",
  componentId: "ez1h3h-0"
})(({
  theme,
  $multiRow
}) => ({
  borderLeft: `1px solid ${theme.color['border-core-default']}`,
  height: '33px',
  marginInlineStart: theme.space['200'],
  marginInlineEnd: theme.space['200'],
  display: $multiRow ? 'none' : 'inline-block'
}));
export default function Divider({
  multiRow
}) {
  return /*#__PURE__*/_jsx(DividerDiv, {
    $multiRow: multiRow
  });
}